// extracted by mini-css-extract-plugin
export var content = "_dh-3";
export var list = "_dh-4";
export var settingsContent = "_dh-7";
export var settingsPanel = "_dh-8";
export var state = "_dh-6";
export var triggerBadge = "_dh-2";
export var triggerButton = "_dh-1";
export var triggerShell = "_dh-0";
export var unreadDot = "_dh-5";